module.exports = __webpack_public_path__ + "img/settings.deb0a6b2.svg";